module.exports = "/_next/static/images/fcd866bbbcaf46cef31e185218ee1892-icon-2.svg.webp";